import React from "react";
import "./about.css";
import AboutImg from "../../assets/profile.jpg";
import CV from "../../assets/raj-cv.pdf";
import Info from "./Info";
import { motion } from "framer-motion";
const About = () => {
  return (
    <section className="about section" id="about">
      <h2 className="section__title">About me</h2>
      <span className="section__subtitle">My introduction</span>

      <div className="about__container container grid">
        <img src={AboutImg} alt="aboutimg" className="about__img" />
        <div className="about__data">
          <Info />
          <p className="about__description">
            I'm open to Job opportunities where I can contribute, learn and
            grow. If you have a good opportunity that matches my skills and
            experience then don't hesitate to contact me.
          </p>
          <motion.a
            transition={{ duration: 0.1 }}
            whileHover={{
              scale: 1.05,
            }}
            whileTap={{ scale: 0.95 }}
            download=""
            href={CV}
            className="button button--flex"
          >
            Download CV
            <i className="uil uil-file-download-alt button__icon"></i>
          </motion.a>
        </div>
      </div>
    </section>
  );
};

export default About;
